const StatusMessage = ({ statusMessage }: { statusMessage: string }) => (
  <div className="flex justify-center items-center h-full font-semibold text-lg text-navy-black font-sans">
    {statusMessage}
  </div>
);
export default StatusMessage;
